<template>
  <div class="home">
    <NavBar
      navIndex="1"
      :imgHeight="vdaH"
    ></NavBar>
    <!-- <div style="padding:30px;"></div> -->
    <div style="background-color:#000;min-width: 1200px;">
      <el-carousel :height="vdaH+ 'px'">
        <el-carousel-item
          v-for="(item,index) in swiperData"
          :key="index"
        >
          <!-- <h3 class="small">{{ item }}</h3> -->
          <div
            @click="goDynamicDetail(item.url)"
            class="carousel-banner"
            :style="{backgroundImage:'url('+item.pic+')'}"
            style="width: 100%;height: 100%;background-size: cover;    background-position: center;"
          ></div>
          <!-- <img
            style="height:100%;width:100%;"
            :style="{'cursor': (item.url? 'pointer':'default')}"
            @click="goDynamicDetail(item.url)"
            :src="item.pic"
            alt=""
          > -->
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 关于弘知 -->
    <div
      class="content-box"
      ref="hz"
    >
      <contentTitle
        text='关于弘知'
        class="animate__animated"
        :class="{animate__fadeInUp:hzShow}"
      />

      <div
        class="explain-box"
        style="box-shadow: 0px 0px 20px 3px #eee;"
      >
        <div class="df jc_sb">
          <div
            style="font-size: 15px;line-height: 32px;letter-spacing: 1px;color: #646a73;padding: 0 40px;width: 50%;"
            class="animate__animated"
            :class="{animate__fadeInUp:hzShow}"
          >湖南弘知教育科技有限公司是一家以教育培训、教育投资和运营管理为主营业务的高科技平台型教育服务企业，旗下拥有弘知培训学校、弘朗培训学校、弘之道培训学校、弘知教育咨询有限公司、隽朗科技有限公司、弘知商学院等多家子公司。
            <br>
            <br>
            弘知在K12教培领域深耕多年，具有强劲的竞争力。在线下教学服务质量获得良好口碑的同时，大力进行线上教育的研发，目前已有一系列线上教育产品面世。公司以弘知集团的成功管理经验为蓝本，开发出系统化的运营课程和信息化企业管理系统，致力于为相关行业提供完善的运营管理解决方案；坚持“依托教育、整合资源、打造品牌、提供 价值”的方针，积极探索教育多元化发展之路，践行服务社会的责任，目前多个业务板块均在蓬勃发展。
          </div>

          <div
            class="animate__animated"
            :class="{animate__fadeInUp:hzShow}"
            style="width: 50%;padding-right: 40px;"
          >
            <img
              class="scaleImg_hover br-r6"
              style="width: 100%;height: 97%;"
              src="../assets/home-company.png"
              alt=""
            >
          </div>
        </div>
        <div
          class="btn go-about-btn"
          @click="goAbout()"
        >查看详情</div>
      </div>
    </div>

    <div style="position:relative;min-width: 1200px;">
      <img
        style="width: 100%;min-height: 620px;"
        src="../assets/home-page/bg.png"
        alt=""
      >

      <div
        class="course-show-box "
        ref="course"
      >
        <contentTitle
          text='课程介绍'
          class="animate__animated"
          :class="{animate__fadeInUp:courseShow}"
        />

        <div
          class="course-big-box animate__animated"
          :class="{animate__fadeInUp:courseShow}"
        >
          <div
            class="course-cell one-course-cell"
            v-for="(item,index) in courseList"
            :key="index"
          >
            <img
              class="scaleImg_hover br-r6"
              style="width:100%"
              :src="item.img"
              alt=""
            >
            <div style="padding:10px 0;">
              <div class="content-title-box content-title-box2">
                {{item.title}}
                <div
                  class="content-title-border"
                  style="width: 30px;height:2px;bottom: -30%;"
                ></div>
              </div>
              <div class="course-text">{{item.content}}</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div
      style="padding:50px 0 30px 0;"
      ref="shizi"
      class="shizi"
    >
      <contentTitle
        text='师资力量'
        class="animate__animated"
        :class="{animate__fadeInUp:shiziShow}"
      />

      <div style="width: 1200px;margin: 60px auto 0px;">
        <el-carousel
          indicator-position="outside"
          height='400px'
        >
          <el-carousel-item
            v-for="(item,index) in teacherTagData"
            :key="index"
          >
            <div style="display: flex;">
              <!-- Box lef -->
              <div style="position: relative; margin: 0px 25px; width: 366px; height: 400px;">
                <img
                  style="width: 100%;"
                  :src="item.children[0].teacherPic"
                  alt=""
                  class="scaleImg_hover br-r6"
                >
                <div style="position: absolute;left:0;bottom:0;">
                  <img
                    style="display: block;"
                    src="../assets/name-bg.png"
                    alt=""
                  >
                  <div class="teacherName">{{item.children[0].teacherName}}</div>
                </div>
              </div>

              <!--Box right -->
              <div
                style="display: flex; flex-direction: column; justify-content: space-between;"
                class=" animate__animated"
                :class="{animate__fadeInUp:shiziShow}"
              >
                <div style="font-size: 24px; color: rgb(153, 153, 153);">
                  <span style="font-size: 38px; color: rgb(153, 153, 153); padding: 15px 0; margin-right: 10px;">0{{index+1}}</span>{{item.tagName}}
                </div>
                <div style="width: 742px; line-height: 32px; font-size: 15px;">
                  {{item.tagDesc}}
                </div>
                <div style="display: flex; justify-content: space-between;">
                  <div
                    style="position: relative; width: 164px; height: 190px;"
                    v-for="(item_t,index_t) in item.children"
                    :key="index_t"
                    :class="index_t==0?'dp_none':''"
                  >
                    <img
                      :src="item_t.teacherPic"
                      alt=""
                      class="scaleImg_hover br-r6"
                      style="width: 100%; height: 100%;"
                    >
                    <div style="position: absolute;left:0;bottom:0;">
                      <img
                        style="display: block;width: 90px;height: 20px;"
                        src="../assets/name-bg.png"
                        alt=""
                      >
                      <div class="teacherName">{{item_t.teacherName}}</div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- <div class="teadcher-show-box">
        <div>
          <div
            v-for="(item,index) in teacherTagData"
            :key="index"
            style="display:flex;align-items:center;width:300px;height: 80px;cursor:pointer;"
            :style="{'background-color': (item.status? '#005BB0':'#fff')}"
            @click="selectTeacherTag(item,index)"
          >
            <div
              style="font-size: 38px;color:#fff;padding:15px;margin-right:10px;"
              :style="{'color': (item.status? '#fff':'#999999')}"
            >0{{index + 1}}</div>
            <div
              style="font-size:24px;color:#fff;"
              :style="{'color': (item.status? '#fff':'#999999')}"
            >{{item.tagName}}</div>
          </div>
        </div>

        <div style="display: flex;">
          <div style="position: relative;margin: 0 25px;width: 320px;height: 400px;">
            <img
              class="scaleImg_hover"
              :src="bigTeacher.pic"
              style="width: 320px;height: 400px;"
              alt=""
            >
            <div style="position: absolute;left:0;bottom:0;">
              <img
                style="display: block;"
                src="../assets/name-bg.png"
                alt=""
              >
              <div style="position: absolute;left:45%;top:50%;transform: translate(-50%,-50%);">{{bigTeacher.t_name}}</div>
            </div>
          </div>

          <div style="display: flex;flex-direction: column;justify-content: space-between;">

            <div
              style="width: 500px;line-height: 32px;font-size: 15px;"
              class="animate__animated"
              :class="{animate__fadeInUp:shiziShow}"
            >
              {{teacherText}}
            </div>

            <div style="text-align: right;">
              <img
                @click="goTeacher()"
                style="width: 40px;"
                src="../assets/click-img.png"
                alt=""
              >
            </div>

            <div style="display: flex;justify-content: space-between;">
              <div
                v-for="(item_t,index) in teacherData"
                :key="index"
                style="position: relative;width: 110px;height:140px;"
              >
                <img
                  class="scaleImg_hover"
                  style="width: 100%;height:100%;"
                  :src="item_t.teacherPic"
                  alt=""
                >
                <div style="position: absolute;left:0;bottom:0;">
                  <img
                    style="display: block;width: 90px;height: 20px;"
                    src="../assets/name-bg.png"
                    alt=""
                  >
                  <div style="position: absolute;left:45%;top:50%;transform: translate(-50%,-50%);font-size: 14px;">{{item_t.teacherName}}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div> -->
    </div>

    <div
      class="content-box"
      style="background-color: #F8FBFF;"
      ref="album"
    >
      <contentTitle
        text='弘知相册'
        class="animate__animated"
        :class="{animate__fadeInUp:albumShow}"
      />

      <div
        style="width: 1200px;margin: 60px auto 40px;"
        class="animate__animated"
        :class="{animate__fadeInUp:albumShow}"
      >
        <el-carousel height="355px">
          <el-carousel-item
            v-for="(item,index) in photoData"
            :key="index"
          >

            <div class="show-photo-box">
              <div
                class="photo-box"
                v-for="(item_z,index) in item"
                :key="index"
              >
                <img
                  @click="clickImg(item_z)"
                  class="photo-img scaleImg_hover"
                  :src="item_z.pic"
                  alt=""
                >
                <div class="photo-text">{{item_z.picDesc}}</div>
              </div>
            </div>

          </el-carousel-item>
        </el-carousel>
      </div>

      <img
        @click="goPhoto()"
        style="width: 80px;margin: auto;display: block;"
        src="../assets/photo_mor.png"
        alt=""
      >
      <!-- <view style="width:35px;height:15px;margin: auto;display: block;">更多</view> -->
    </div>

    <!-- 弘知相册查看大图 -->
    <div
      v-if="lookBigImg"
      style="display: flex;justify-content: center;align-items: center;position: fixed;width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.9);top: 0;left: 0;z-index: 15;"
    >
      <i
        @click="closeImg()"
        class="el-icon-circle-close"
        style="position: absolute;right:80px;top: 120px;color: #fff;font-size: 40px;cursor: pointer;"
      ></i>
      <el-carousel
        :interval="4000"
        :initial-index="carousel_index"
        type="card"
        height="600px"
        style="width: 1200px;"
      >
        <el-carousel-item
          v-for="(item,index) in bigImgData"
          :key="index"
          style="display: flex;align-items: center;justify-content: center;"
        >
          <div style="position: relative;width: 600px;height: 480px;">
            <img
              style="display: block;width: 100%;width: 600px;height: 480px;object-fit: cover;"
              :src="item.pic"
              alt=""
            >
            <div class="photo-carousel-text">
              {{item.picDesc}}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import NavBar from "@/components/navBar.vue";
import Footer from "@/components/Footer.vue";
// import {logOut} from '@/request/api'
import { homeImg } from "@/request/api";
import { homeTag } from "@/request/api";
import { homeTeacher } from "@/request/api";

export default {
  name: "home",
  components: {
    NavBar,
    Footer,
  },
  data: function () {
    return {
      swiperData: [""], //首页轮播图
      teacherTagData: [{}], // 科目数据
      teacherData: {
        children: [
          { teacherPic: "../assets/name-bg.png" },
          { teacherPic: "../assets/name-bg.png" },
          { teacherPic: "../assets/name-bg.png" },
          { teacherPic: "../assets/name-bg.png" },
          { teacherPic: "../assets/name-bg.png" },
        ],
      }, // 老师信息的数据
      teacherText: "", // 说明
      bigTeacher: {}, // 展示的老师大图
      photoData: [],
      lookBigImg: false, // 是否查看大图
      bigImgData: [],
      carousel_index: 0, // 查看大图轮播的索引
      hzShow: false,
      courseShow: false,
      shiziShow: false,
      albumShow: false,
      vdaH: 0,
      courseList: [
        {
          img: require("../assets/home-page/1.png"),
          title: "一对一课堂",
          content:
            "专属教师一对一教学，每位学生配备专门的学习管理师进行课前课后跟踪服务。",
        },
        {
          img: require("../assets/home-page/2.png"),
          title: "常规班课",
          content:
            "6-20人的不同班型，春暑秋寒四期全科目覆盖，分为同步、提高、培优等层次。",
        },
        {
          img: require("../assets/home-page/3.png"),
          title: "专题突破课程",
          content:
            "各科目针对特定专项内容开设的短期突破课程，短时间内提升学生的薄弱板块。",
        },
        {
          img: require("../assets/home-page/4.png"),
          title: "全日制课程",
          content:
            "全天候一对一教学，专属学管师贴心服务， 包含早晚自习与周测等全方位学习环节。",
        },
      ],
    };
  },
  created() {
    this.vdaH = this.clientHeight();
  },
  mounted() {
    let that = this;
    homeImg("pageSize=8&pageNum=1&type=5").then((res) => {
      that.swiperData = res.data.result;
    });

    homeImg("pageSize=12&pageNum=1&type=4").then((res) => {
      let data = res.data.result;

      // 把图片存入查看大图
      // let arr = []
      // for(let i = 0;i < data.length;i++){
      //   arr.push(data[i])
      // }
      // that.bigImgData = arr
      // console.log("看大图",that.bigImgData)
      that.bigImgData = data;

      function spArr(arr, num) {
        //arr是你要分割的数组，num是以几个为一组
        let newArr = []; //首先创建一个新的空数组。用来存放分割好的数组
        for (let i = 0; i < arr.length; ) {
          //注意：这里与for循环不太一样的是，没有i++
          newArr.push(arr.slice(i, (i += num)));
        }
        return newArr;
      }
      that.photoData = spArr(data, 4);
    });

    homeTag().then((res) => {});

    homeTeacher().then((res) => {
      let data = res.data.data;
      let childData = [];
      data.forEach(function (res, index) {
        if (index === 0) {
          res.status = true;
        } else {
          res.status = false;
        }

        res.children = res.children.slice(0, 5);
      });
      that.teacherTagData = data; // 总的数据
      // console.log(data);
      let t_data = [];
      let t_obj = {
        pic: data[0].children[0].teacherPic,
        t_name: data[0].children[0].teacherName,
      };
      that.bigTeacher = t_obj;

      let ii;
      if (data[0].children.length < 5) {
        ii = data[0].children.length;
      } else {
        ii = 5;
      }
      for (let i = 1; i < ii; i++) {
        t_data.push(data[0].children[i]);
      }
      that.teacherData = t_data;
      that.teacherText = that.teacherTagData[0].tagDesc;
    });

    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 师资力量。选择科目老师
    selectTeacherTag(index) {
      let that = this;
      let data = that.teacherTagData;
      data.forEach(function (res, index2) {
        res.status = false;
      });
      data[index].status = true;

      let t_data = [];
      let t_obj = {
        pic: data[index].children[0].teacherPic,
        t_name: data[index].children[0].teacherName,
      };
      that.bigTeacher = t_obj;

      let ii;
      if (data[index].children.length < 5) {
        ii = data[index].children.length;
      } else {
        ii = 5;
      }
      for (let i = 1; i < ii; i++) {
        t_data.push(data[index].children[i]);
      }
      that.teacherData = t_data;
      that.teacherText = that.teacherTagData[index].tagDesc;
    },
    handleScroll() {
      let _this = this;
      let refArray = [
        { ref: "course", show: "courseShow" },
        { ref: "shizi", show: "shiziShow" },
        { ref: "hz", show: "hzShow" },
        { ref: "album", show: "albumShow" },
      ];
      refArray.forEach((r, i) => {
        _this.gdjz(r.ref, () => {
          _this[r.show] = true;
        });
      });
    },
    goAbout() {
      this.$router.push({ name: "about", query: { type: "企业简介" } });
    },

    // 去课程页
    goCourse() {
      this.$router.push({ name: "course", query: { type: "课程设置" } });
    },

    // 去师资页
    goTeacher() {
      this.$router.push({ name: "teacher" });
    },

    // 去往相册页
    goPhoto() {
      this.$router.push({ name: "photoAlbum", query: { type: "多彩校区" } });
    },
    clickImg(e) {
      console.log(e);
      let that = this;
      let data = that.bigImgData;
      console.log("img", data);
      data.forEach(function (res, index) {
        if (res.id === e.id) {
          console.log("id", res.id);
          that.carousel_index = index;
          console.log("index", index);
        }
      });
      that.lookBigImg = true;
    },
    // 关闭查看大图
    closeImg() {
      this.lookBigImg = false;
    },
    // 跳转到新闻详情
    goDynamicDetail(e) {
      console.log(e);
      if (e) {
        window.open(e);
      }
      //
    },
  },
};
</script>
<style scoped>
.content-box {
  position: relative;
  padding: 50px 50px 100px;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.content-title-box {
  line-height: 45px;
  font-size: 28px;
  position: relative;
  text-align: center;
  color: #1f2329;
  font-family: PingFang-Bold;
}

.content-title-box2 {
  font-size: 20px;
  line-height: 36px;
}

.content-title-border {
  position: absolute;
  width: 32px;
  height: 4px;
  background-color: #0050a7;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15%;
}
.explain-box {
  width: 1200px;
  background-color: #fff;
  margin: 50px auto 0;
  padding: 30px 0;
}

/* 课程 */
.course-show-box {
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  width: 1200px;
}
.course-big-box {
  margin: 40px auto 0;
  display: flex;
  justify-content: space-between;
  width: 1200px;
}
.course-text {
  padding: 18px;
  font-size: 14px;
  color: #5f6464;
  letter-spacing: 0;
  line-height: 25px;
}
.course-cell {
  position: relative;
  background-color: #fff;
  width: 280px;
}
.one-course-cell:hover .course-cell-hover {
  display: block;
}

.course-cell-hover {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.course-hover-content {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 100%;
  padding: 50px 30px;
  box-sizing: border-box;
}
.course-hover-text {
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 1px;
}
/* 师资力量 */
.teadcher-show-box {
  display: flex;
  width: 1200px;
  margin: 60px auto 0px;
  justify-content: center;
}

/* 相册 */
.show-photo-box {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.photo-box {
  width: 280px;
  margin: 10px;
  background-color: #fff;
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
}
.photo-box:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}
.photo-img {
  width: 280px;
  height: 224px;
  object-fit: cover;
}
.photo-text {
  padding: 5px 10px 10px;
  line-height: 28px;
  font-size: 14px;
  color: #5f6464;
}
.photo-carousel-text {
  position: absolute;
  bottom: 0;
  padding: 15px;
  color: #fff;
  background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  max-height: 80px;
  overflow: hidden;
  line-height: 30px;
  width: 100%;
  box-sizing: border-box;
}

.go-about-btn {
  margin-top: 38px;
  margin-left: 40px;
}

.teacherName {
  position: absolute;
  left: 45%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}

.dp_none {
  display: none;
}

.shizi :deep .el-carousel__container{
  margin-bottom: 34px;
}
</style>
